import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Personnel Space Cluster Assignment: The association(s) between personnel and space cluster.',
    name: 'Personnel Space Cluster Assignments',
    partialId: PartialId.Standard.create('person_space_cluster'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
